// extracted by mini-css-extract-plugin
module.exports = {"main":"StarsReview_main__YvhwS","review":"StarsReview_review__QaCpR","reviewTextWhite":"StarsReview_reviewTextWhite__YMIQ1"};